<template>
  <div class="upload-img" :style="{'backgroundImage': data.loading || data.image?'':`url(${bgImg})`}" :class="{done: data.image}">
    <a-upload
      :accept="accept"
      list-type="picture-card"
      class="card-uploader "

      :show-upload-list="false"
      :data="data"
      :customRequest="uploadRequest"
    >
      <img v-if="!data.loading && data.image && bucketType !== '3'" :src="`${data.image.indexOf('app/')>-1? constv.QINIU_AVATAR_CND_URL : domainMap[this.bucketType]}${data.image}`" alt="" />
      <img v-if="data.image && bucketType === '3'" :src="`${idCardBase64}`" alt="" />
      <div v-else></div>
    </a-upload>

    <slot name="reset-btn" v-if="data.image">
      <!-- 按钮样式 -->
      <div class="mask" >
        <a-button
          class="upload-btn"
          type="primary"
        >重新上传</a-button>
      </div>
    </slot>
    <!-- 进度条样式 -->
    <slot name="process" :loading="data.loading" :percent="data.percent">
      <div class="process-box" v-if="data.loading">
        <div class="process" >
          <div class="wrap-in" :style="{'width':data.percent + '%'} "></div>
        </div>
      </div>
    </slot>

    <slot name="close">

    </slot>

    <image-clip

      ref="imageClip"
      :imgFile="imgFile"
      @upload="onClipSuccess"
      :fileName="fileName"
      :clipOption="clipOption"
    >

    </image-clip>

  </div>
</template>

<script>
import { getRandom, getBase64, dataURLtoBlobs, blobToFile } from '@/utils/util.js'
import { mapActions } from 'vuex'
import ImageClip from '@/components/Zpace/clip/ImageClip.vue'
import * as qiniu from 'qiniu-js'
export default {
  components: {
    ImageClip
  },
  props: {
    // type: {
    //   type: String,
    //   default: 'idCard'
    // },
    clipOption: {
      type: Object,
      default: () => {
        return {
          autoCropWidth: 340,
          autoCropHeight: 269,
          fixedNumber: [340, 269]
        }
      }
    },
    clip: {
      type: Boolean,
      default: false
    },
    bucketType: {
      type: String,
      default: '1' //	1:正常图片  2：水印图片  3：私用空间 4. 用户资源 5. qnc 域名
    },
    data: {
      default: () => {
        return {
          image: '',
          loading: false,
          percent: 0
        }
      },
      type: Object
    },
    path: {
      type: String,
      default: 'resources/cloud/idCard_web/'
    },
    bgImg: {
      type: String,
      default: require('../../../assets/img/img_id_card_z_200_125@2x.png')
    },
    limit: {
      type: Number, // 单位 kb
      default: 0
    },
    accept: {
      type: String,
      default: '.jpeg,.png,.jpg'
    },
    checkSize: {
      type: Function,
      default: () => {
        return new Promise((resolve, reject) => {
          resolve('OK')
        })
      }
    },
    addWaterImage: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showClip: false,
      domainMap: {
        '1': this.constv.QINIU_IMAGE_CND_URL,
        '2': this.constv.QINIU_IMAGE_WATERMARK_CND_URL,
        '3': '',
        '4': this.constv.QINIU_IMAGE_USERRESOURCE_CND_URL,
        '5': this.constv.QINIU_IMAGE_QNC_CDN_URL
      },
      idCardBase64: '',
      imgFile: '',
      fileName: ''
    }
  },
  methods: {
    ...mapActions(['getQiniuToken']),
    name () {
      return getRandom(4) + Math.floor(new Date().getTime() / 1000) + getRandom(4)
    },
    onClipSuccess (file, fileName) {
      this.postImage(blobToFile(dataURLtoBlobs(file), fileName), fileName)
    },
    async uploadRequest ({ action,
      data,
      file,
      filename,
      headers,
      onError,
      onProgress,
      onSuccess,
      withCredentials }) {
      const isJpgOrPng = this.accept.split(',').findIndex((item) => {
        return file.type.indexOf(item.replace(/\./g, '')) > -1
      })
      console.log(file.type, isJpgOrPng)
      if (isJpgOrPng < 0) {
        this.$message.error(`只能上传${this.accept.replace(/\./g, '').replace(/,/g, '、')}格式的图片`)
        // this.data.error = `素材格式有误，请重新上传: 格式`
        // this.data.errorType = '1'
        return false
      } else {
        this.data.error = ''
      }

      if (this.limit) {
        const isLimit = file.size / 1024 < this.limit
        if (!isLimit) {
          this.$message.error(`只能上传小于${this.limit > 1000 ? Math.floor(this.limit / 1000) + 'M' : this.limit + 'kb'}的图片`)
          // this.data.error = '素材格式有误，请重新上传: 大小'
          // this.data.errorType = '2'
          return false
        } else {
          this.data.error = ''
        }
      }

      if (this.clip) {
        this.fileName = file.name
        getBase64(file, (oimg) => {
          let image = new Image()
          image.src = oimg
          image.onerror = () => {
            image = null
            this.$message.error('图片大小有误，请重新上传')
          }
          image.onload = () => {
            this.imgFile = oimg
            this.$refs.imageClip.showClip = true
            image = null
          }
        })
      } else {
        // 检查尺寸
        this.checkSize(file, data).then(async res => {
          this.postImage(file, filename)
        }).catch((e) => {
          console.log(e)
        })
      }
    },
    // 上传到七牛
    async postImage (file, filename) {
      const upload = new Promise(async (resolve, reject) => {
        const sendData = {
          action: 'upload',
          bucketType: this.bucketType
        }
        // 获取七牛上传token
        await this.getQiniuToken(sendData)

        const params = {
          token: this.$store.state.texture.token,
          key: `${this.path}${this.name()}.${
            file.type.split('/')[1]
          }`
        }
        this.data.image = ''
        this.data.loading = true
        // 上传到七牛 拿到图片地址
        const observable = qiniu.upload(file, params.key, params.token)
        observable.subscribe({
          next: (result) => {
          // 主要用来展示进度
            console.log(result.total.percent)
            this.data.percent = Math.round(result.total.percent).toFixed(0)
          },
          error: () => {
            this.$message.error('上传图片失败')
            reject(new Error('上传图片失败'))
          },
          complete: (response) => {
            if (this.bucketType === '3') { // 私有空间用base64 显示
            // getBase64(file, (base64) => {
            //   this.idCardBase64 = base64
            // })
              this.$api.qiniu.getPrivateImageUrl({ url: response.key, water_mark: '|idcard_wm' }).then(result => {
                this.idCardBase64 = result.data.auth_token
              })
            }
            this.data.image = response.key // 返回的路径
            this.errTips = ''

            resolve(response)
          }
        })
      })

      if (this.addWaterImage) {
        const water = this.addWaterMark(file, this.path)
        Promise.all([water, upload]).then((values) => {
          console.log(values)
          this.data.loading = false
          this.$emit('onSuccess', values[1], filename, file, this.data)
        })
      } else {
        upload.then((response) => {
          this.data.loading = false
          this.$emit('onSuccess', response, filename, file, this.data)
        })
      }
    },
    // 添加水印
    addWaterMark (file, path) {
      return new Promise(async (resolve, reject) => {
        // 生成水印名字
        const waterMarkKey = `${path}${this.name()}.${file.type.split('/')[1]}`
        // 上传水印图片
        const sendData = {
          action: 'upload',
          bucketType: '2'
        }
        await this.getQiniuToken(sendData)

        // 上传到七牛 拿到图片地址
        const observable = qiniu.upload(file, waterMarkKey, this.$store.state.texture.token)
        observable.subscribe({
          next: (result) => {
          // 主要用来展示进度
          },
          error: () => {
            this.$message.error('上传水印图片失败')
            reject(new Error('上传水印图片失败'))
          },
          complete: (response) => {
            this.data.watermark_image = response.key // 返回的路径
            resolve(response)
          }
        })
      })
    }
  }

}
</script>

<style scoped lang="less">

.upload-img{
    background-size: 100% 100%;
    background-color: #fafafa;
    background-image: url('../../../assets/img/material_bg.jpg');
    background-repeat: no-repeat;
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    border-radius: 8px;
    border: 1px dashed #E5E5E5;
    &:hover {
      border-color: @primary-color;
    }
    &.done {
        border: 1px solid #f2f2f2;
    }

    &:hover {
      .mask {
        display: flex;
        pointer-events: none;
        /deep/
        .upload-btn {
          padding: 0;
          display: block;
          width: 75px;
          height: 30px;
          pointer-events: none;
        }
      }
    }
    img {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%,-50%);
      max-width: 100%;
      max-height: 100%;
    }
    .process-box {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 25px;
      pointer-events: none;
      .process {
        width: 100%;
        border-radius: 8px;
        border:1px solid @primary-color;
        padding: 0 5px;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        height: 16px;
        .wrap-in {
          width: 20%;

          border-radius: 4px;
          height: 8px;
          background-color: @primary-color;
        }
      }
    }
    .mask {
      pointer-events: none;
        display: none;
        position: absolute;
        border-radius: 4px;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);

        justify-content: center;
        align-items: center;
    }

    /deep/
    .ant-upload.ant-upload-select-picture-card {
      background: none;
    }
    /deep/
    .ant-upload-picture-card-wrapper {
      height: 100%;
    }

}
</style>
